export default "<app-view></app-view>\n\n<router-outlet></router-outlet>\n"